import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import api from '../api/axios';

const ITEM_TYPES = ['Gangsaw','Balance Drill Bit','Big Drill Bit','Waste Rope','Other'];
const UNITS = ['SQFT','NOS','KG','METER','LOT'];
const PAYMENT_MODES = [
  { val:'CASH',     label:'Cash' },
  { val:'BANK',     label:'Bank Transfer' },
  { val:'CHEQUE',   label:'Cheque' },
  { val:'UPI',      label:'QR Code / UPI' },
  { val:'RAZORPAY', label:'Razorpay' },
];
const DIRECTIONS = [
  { val:'N', label:'North' },
  { val:'S', label:'South' },
  { val:'E', label:'East' },
  { val:'W', label:'West' },
];

const inr = v => `₹${Number(v||0).toLocaleString('en-IN', { minimumFractionDigits:2 })}`;
const Field = ({ label, required, children, full }) => (
  <div className="form-group" style={full?{gridColumn:'1/-1'}:{}}>
    <label className="form-label">{label}{required&&<span style={{ color:'var(--red)',marginLeft:3 }}>*</span>}</label>
    {children}
  </div>
);
const ST = ({ children }) => (
  <div style={{ fontSize:11, fontWeight:700, letterSpacing:'1.2px', textTransform:'uppercase', color:'var(--brand)', borderBottom:'2px solid var(--border)', paddingBottom:8, marginBottom:16 }}>{children}</div>
);

export default function SalesOrderForm({ isQuotation=false }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = !!id;

  const [customers, setCustomers]   = useState([]);
  const [allGangsaws, setAllGangsaws] = useState([]);
  const [gangsaws, setGangsaws]     = useState([]);
  const [saving, setSaving]         = useState(false);
  const [error, setError]           = useState('');
  const [showPayModal, setShowPayModal] = useState(false);
  const [showDispatchModal, setShowDispatchModal] = useState(false);
  const [order, setOrder]           = useState(null);
  const [payments, setPayments]     = useState([]);
  const [selectedDirection, setSelectedDirection] = useState('');

  const today = new Date().toISOString().split('T')[0];
  const validUntil = new Date(Date.now() + 15*24*60*60*1000).toISOString().split('T')[0];

  const [form, setForm] = useState({
    customer: '', order_date: today, delivery_date: '', delivery_address: '',
    notes: '', discount_percent: 0, cgst_percent: 9, sgst_percent: 9,
    valid_until: validUntil, items: [],
  });

  const [newItem, setNewItem] = useState({ item_type:'Gangsaw', gangsaw_id:'', description:'', quantity:'', unit:'SQFT', unit_price:'' });
  const [payForm, setPayForm] = useState({ amount:'', payment_mode:'CASH', payment_date:today, reference_number:'', notes:'' });
  const [dispForm, setDispForm] = useState({
    dispatch_date:today, vehicle_number:'', driver_name:'', driver_phone:'',
    lr_number:'', transport_company:'', freight_amount:'', driver_payment:'',
    diesel_amount:'', loading_charges:'', unloading_charges:'', other_expenses:'',
    delivery_address:'', notes:''
  });

  const setF  = (k,v) => setForm(f=>({...f,[k]:v}));
  const setNI = (k,v) => setNewItem(n=>({...n,[k]:v}));
  const setPF = (k,v) => setPayForm(p=>({...p,[k]:v}));
  const setDF = (k,v) => setDispForm(d=>({...d,[k]:v}));

  useEffect(() => {
    api.get('/sales/customers/?page_size=200').then(r=>setCustomers(r.data.results||[]));
    // Load all COMPLETED gangsaws
    api.get('/production/slabs/?page_size=500&status=PASSED').then(r=>{
      setAllGangsaws(r.data.results||[]);
      setGangsaws(r.data.results||[]);
    });
    if(isEdit) {
      api.get(`/sales/orders/${id}/`).then(r=>{
        const o = r.data.data || r.data;
        setOrder(o); setPayments(o.payments||[]);
        setForm({
          customer: o.customer, order_date: o.order_date,
          delivery_date: o.delivery_date||'', delivery_address: o.delivery_address||'',
          notes: o.notes||'', discount_percent: o.discount_percent||0,
          cgst_percent: o.cgst_percent||9, sgst_percent: o.sgst_percent||9,
          items: o.items||[],
        });
      });
    }
  }, [id, isEdit]);

  // Filter gangsaws by direction
  const handleDirectionChange = (dir) => {
    setSelectedDirection(dir);
    setNI('gangsaw_id', '');
    if(!dir) {
      setGangsaws(allGangsaws);
      return;
    }
    // Filter by direction using block_number: BLK/2026/N/0001 → parts[2] = 'N'
    const filtered = allGangsaws.filter(g => {
      const parts = (g.block_number||'').split('/');
      const blockDir = parts.length >= 4 ? parts[2] : '';
      return blockDir === dir;
    });
    setGangsaws(filtered);
  };

  // Calculations
  const subtotal = form.items.reduce((s,item)=>s+parseFloat(item.total_price||0),0);
  const discountAmt = subtotal * parseFloat(form.discount_percent||0) / 100;
  const taxable = subtotal - discountAmt;
  const cgst = taxable * parseFloat(form.cgst_percent||9) / 100;
  const sgst = taxable * parseFloat(form.sgst_percent||9) / 100;
  const total = taxable + cgst + sgst;

  const addItem = () => {
    if(!newItem.description || !newItem.quantity || !newItem.unit_price) {
      setError('Fill item description, quantity and price.'); return;
    }
    setError('');
    const totalPrice = parseFloat(newItem.quantity) * parseFloat(newItem.unit_price);
    const selG = allGangsaws.find(g=>g.id===newItem.gangsaw_id);
    const dirLabel = selectedDirection ? DIRECTIONS.find(d=>d.val===selectedDirection)?.label||selectedDirection : '';
    setForm(f=>({ ...f, items:[...f.items, {
      description: newItem.item_type==='Gangsaw' && newItem.gangsaw_id
        ? `Gangsaw — ${selG?.slab_code||''} ${dirLabel?`(${dirLabel})`:''}`
        : newItem.description,
      quantity: newItem.quantity, unit: newItem.unit,
      unit_price: newItem.unit_price,
      total_price: totalPrice.toFixed(2),
      slab: newItem.item_type==='Gangsaw' ? newItem.gangsaw_id : null,
    }] }));
    setNewItem({ item_type:'Gangsaw', gangsaw_id:'', description:'', quantity:'', unit:'SQFT', unit_price:'' });
  };

  const removeItem = idx => setForm(f=>({ ...f, items: f.items.filter((_,i)=>i!==idx) }));

  const handleSave = async () => {
    if(!form.customer) { setError('Please select a customer.'); return; }
    if(form.items.length===0) { setError('Please add at least one item.'); return; }
    setSaving(true); setError('');
    try {
      const payload = {
        customer: form.customer, order_date: form.order_date,
        delivery_date: form.delivery_date||null, delivery_address: form.delivery_address,
        notes: form.notes, discount_percent: form.discount_percent,
        cgst_percent: form.cgst_percent, sgst_percent: form.sgst_percent,
        subtotal: subtotal.toFixed(2),
        status: isQuotation ? 'DRAFT' : 'CONFIRMED',
      };
      let orderId = id;
      if(isEdit) {
        await api.patch(`/sales/orders/${id}/`, payload);
      } else {
        const res = await api.post('/sales/orders/', payload);
        orderId = res.data?.data?.id || res.data?.id;
      }
      if(!isEdit) {
        for(const item of form.items) {
          await api.post(`/sales/orders/${orderId}/items/`, item);
        }
      }
      navigate(`/sales/order/${orderId}`);
    } catch(e) {
      setError(e.response?.data?.detail || 'Failed to save order.');
    } finally { setSaving(false); }
  };

  const handlePayment = async () => {
    if(!payForm.amount || !payForm.payment_mode) { setError('Fill payment amount and mode.'); return; }
    setSaving(true);
    try {
      await api.post(`/sales/orders/${id}/payments/`, payForm);
      const r = await api.get(`/sales/orders/${id}/`);
      const o = r.data.data || r.data;
      setOrder(o); setPayments(o.payments||[]);
      setShowPayModal(false);
      setPayForm({ amount:'', payment_mode:'CASH', payment_date:today, reference_number:'', notes:'' });
    } catch(e) { setError('Payment failed.'); }
    finally { setSaving(false); }
  };

  const handleDispatch = async () => {
    if(!dispForm.vehicle_number) { setError('Vehicle number is required.'); return; }
    setSaving(true);
    try {
      const dispPayload = {
        ...dispForm,
        notes: [
          dispForm.notes,
          dispForm.driver_payment    ? `Driver Payment: ₹${dispForm.driver_payment}`    : '',
          dispForm.diesel_amount     ? `Diesel: ₹${dispForm.diesel_amount}`              : '',
          dispForm.loading_charges   ? `Loading: ₹${dispForm.loading_charges}`           : '',
          dispForm.unloading_charges ? `Unloading: ₹${dispForm.unloading_charges}`       : '',
          dispForm.other_expenses    ? `Other Expenses: ₹${dispForm.other_expenses}`     : '',
        ].filter(Boolean).join(' | '),
      };
      await api.post(`/sales/orders/${id}/dispatch/`, dispPayload);
      await api.patch(`/sales/orders/${id}/`, { status:'DISPATCHED' });
      navigate('/sales');
    } catch(e) { setError('Dispatch failed.'); }
    finally { setSaving(false); }
  };

  const paidAmt = payments.reduce((s,p)=>s+parseFloat(p.amount||0),0);
  const balAmt  = parseFloat(order?.total_amount||total) - paidAmt;

  return (
    <Layout
      title={isEdit ? `Order — ${order?.order_number||''}` : isQuotation ? 'New Quotation' : 'New Sales Order'}
      subtitle={isEdit ? `${order?.customer_name||''} · ${order?.order_date||''}` : 'Fill all details'}
      actions={<button className="btn btn-secondary btn-sm" onClick={()=>navigate('/sales')}>← Back</button>}
    >
      {error&&<div className="error-box" style={{ marginBottom:16 }}>{error}</div>}

      <div className="sales-form-layout" style={{ display:'grid', gridTemplateColumns:'2fr 1fr', gap:16, alignItems:'start' }}>
        <div>
          {/* Customer */}
          <div className="card" style={{ marginBottom:16 }}>
            <ST>Customer Details</ST>
            <div className="form-grid">
              <Field label="Customer *" full>
                <select className="form-input" value={form.customer} onChange={e=>setF('customer',e.target.value)} disabled={isEdit}>
                  <option value="">Select customer</option>
                  {customers.map(c=><option key={c.id} value={c.id}>{c.name} — {c.phone} {c.city?`(${c.city})`:''}</option>)}
                </select>
                <div style={{ marginTop:6 }}>
                  <button type="button" className="btn btn-sm btn-secondary" onClick={()=>navigate('/sales/customer/new')}>+ Add New Customer</button>
                </div>
              </Field>
              <Field label="Order Date *">
                <input className="form-input" type="date" value={form.order_date} onChange={e=>setF('order_date',e.target.value)} disabled={isEdit}/>
              </Field>
              <Field label={isQuotation ? 'Valid Until' : 'Delivery Date'}>
                <input className="form-input" type="date" value={isQuotation?form.valid_until:form.delivery_date} onChange={e=>setF(isQuotation?'valid_until':'delivery_date',e.target.value)}/>
              </Field>
              <Field label="Delivery Address" full>
                <textarea className="form-input" rows={2} value={form.delivery_address} onChange={e=>setF('delivery_address',e.target.value)} placeholder="Delivery address"/>
              </Field>
              <Field label="Notes" full>
                <textarea className="form-input" rows={2} value={form.notes} onChange={e=>setF('notes',e.target.value)} placeholder="Any special instructions..."/>
              </Field>
            </div>
          </div>

          {/* Items */}
          <div className="card" style={{ marginBottom:16 }}>
            <ST>Items</ST>
            {!isEdit && (
              <div style={{ background:'var(--bg-primary)', borderRadius:'var(--radius-sm)', padding:14, marginBottom:14, border:'1px solid var(--border)' }}>
                <div style={{ fontSize:12, fontWeight:600, color:'var(--text-secondary)', marginBottom:10 }}>Add Item</div>
                <div className="form-grid">
                  <Field label="Item Type">
                    <select className="form-input" value={newItem.item_type} onChange={e=>{
                      setNI('item_type',e.target.value);
                      setNI('description',e.target.value!=='Other'?e.target.value:'');
                      setNI('gangsaw_id','');
                    }}>
                      {ITEM_TYPES.map(t=><option key={t}>{t}</option>)}
                    </select>
                  </Field>

                  {newItem.item_type==='Gangsaw' ? (
                    <>
                      {/* Direction filter */}
                      <Field label="Filter by Direction">
                        <select className="form-input" value={selectedDirection} onChange={e=>handleDirectionChange(e.target.value)}>
                          <option value="">All Directions</option>
                          {DIRECTIONS.map(d=><option key={d.val} value={d.val}>{d.label}</option>)}
                        </select>
                      </Field>
                      <Field label="Select Gangsaw" full>
                        <select className="form-input" value={newItem.gangsaw_id} onChange={e=>{
                          setNI('gangsaw_id',e.target.value);
                          const g = gangsaws.find(g=>g.id===e.target.value);
                          if(g){
                            setNI('quantity', g.area_sqft?.toFixed(2)||'');
                            setNI('unit','SQFT');
                            setNI('description',`Gangsaw — ${g.slab_code}`);
                          }
                        }}>
                          <option value="">Select gangsaw</option>
                          {gangsaws.map(g=>{
                            const blockNum = g.block_number||'';
                            const parts = blockNum.split('/');
                            // BLK/2026/N/0001 → dir=N, serial=0001
                            const dir = parts[2]||'';
                            const serial = parts[3]||parts[2]||'?';
                            const ref = dir && serial
                              ? `${dir}-BOX/${serial}/${g.part_number||'P?'}/${g.slab_number}`
                              : g.slab_code;
                            return (
                              <option key={g.id} value={g.id}>
                                {ref} | Grade {g.quality_grade||'—'} | {g.block_color||'—'}
                              </option>
                            );
                          })}
                        </select>
                      </Field>
                    </>
                  ) : (
                    <Field label="Description">
                      <input className="form-input" value={newItem.description} onChange={e=>setNI('description',e.target.value)} placeholder="Item description"/>
                    </Field>
                  )}

                  <Field label="Quantity">
                    <input className="form-input" type="number" step="0.01" value={newItem.quantity} onChange={e=>setNI('quantity',e.target.value)} placeholder="0.00"/>
                  </Field>
                  <Field label="Unit">
                    <select className="form-input" value={newItem.unit} onChange={e=>setNI('unit',e.target.value)}>
                      {UNITS.map(u=><option key={u}>{u}</option>)}
                    </select>
                  </Field>
                  <Field label="Unit Price (₹)">
                    <input className="form-input" type="number" step="0.01" value={newItem.unit_price} onChange={e=>setNI('unit_price',e.target.value)} placeholder="0.00"/>
                  </Field>
                  <Field label="Total">
                    <input className="form-input" readOnly
                      value={newItem.quantity&&newItem.unit_price?(parseFloat(newItem.quantity)*parseFloat(newItem.unit_price)).toFixed(2):''}
                      style={{ background:'var(--blue-bg)', color:'var(--brand)', fontWeight:700, cursor:'not-allowed' }}/>
                  </Field>
                </div>
                <button type="button" className="btn btn-primary btn-sm" onClick={addItem} style={{ marginTop:8 }}>+ Add Item</button>
              </div>
            )}

            {form.items.length===0 ? (
              <div style={{ textAlign:'center', padding:'20px', color:'var(--text-muted)', fontSize:13 }}>No items added yet.</div>
            ) : (
              <div style={{ overflowX:'auto' }}>
                <table>
                  <thead><tr><th>#</th><th>Description</th><th>Qty</th><th>Unit</th><th>Unit Price</th><th>Total</th>{!isEdit&&<th></th>}</tr></thead>
                  <tbody>
                    {form.items.map((item,i)=>(
                      <tr key={i}>
                        <td style={{ color:'var(--text-muted)', fontSize:12 }}>{i+1}</td>
                        <td style={{ fontWeight:500 }}>{item.description}</td>
                        <td style={{ fontFamily:'DM Mono,monospace' }}>{item.quantity}</td>
                        <td style={{ fontSize:12 }}>{item.unit}</td>
                        <td style={{ fontFamily:'DM Mono,monospace' }}>{inr(item.unit_price)}</td>
                        <td style={{ fontFamily:'DM Mono,monospace', fontWeight:600, color:'var(--brand)' }}>{inr(item.total_price)}</td>
                        {!isEdit&&<td><button type="button" onClick={()=>removeItem(i)} style={{ color:'var(--red)', background:'none', border:'none', cursor:'pointer', fontSize:16 }}>×</button></td>}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* Delivery Expenses — only for dispatched orders */}
          {isEdit && order?.dispatch && (
            <div className="card" style={{ marginBottom:16 }}>
              <ST>Delivery Details & Expenses</ST>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(140px, 1fr))', gap:12 }}>
                {[
                  ['Dispatch Date', order.dispatch.dispatch_date],
                  ['Vehicle Number', order.dispatch.vehicle_number],
                  ['Driver Name', order.dispatch.driver_name||'—'],
                  ['Driver Phone', order.dispatch.driver_phone||'—'],
                  ['Transport Company', order.dispatch.transport_company||'—'],
                  ['LR Number', order.dispatch.lr_number||'—'],
                  ['Freight Amount', order.dispatch.freight_amount?`₹${order.dispatch.freight_amount}`:'—'],
                ].map(([l,v],i)=>(
                  <div key={i} style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid var(--border-light)', fontSize:13 }}>
                    <span style={{ color:'var(--text-muted)' }}>{l}</span>
                    <span style={{ fontWeight:500 }}>{v}</span>
                  </div>
                ))}
              </div>
              {order.dispatch.notes && order.dispatch.notes.includes('₹') && (
                <div style={{ marginTop:14 }}>
                  <div style={{ fontSize:11, fontWeight:700, color:'var(--brand)', textTransform:'uppercase', letterSpacing:'1px', marginBottom:10 }}>Delivery Expenses</div>
                  {order.dispatch.notes.split(' | ').filter(s=>s.includes('₹')).map((expense,i)=>{
                    const [label, amount] = expense.split(':');
                    return (
                      <div key={i} style={{ display:'flex', justifyContent:'space-between', padding:'7px 0', borderBottom:'1px solid var(--border-light)', fontSize:13 }}>
                        <span style={{ color:'var(--text-muted)' }}>{label?.trim()}</span>
                        <span style={{ fontFamily:'DM Mono,monospace', fontWeight:600, color:'var(--brand)' }}>{amount?.trim()}</span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {/* Payments */}
          {isEdit && (
            <div className="card" style={{ marginBottom:16 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
                <ST>Payment History</ST>
                {order?.status!=='CANCELLED'&&<button className="btn btn-primary btn-sm" onClick={()=>setShowPayModal(true)}>+ Record Payment</button>}
              </div>
              {payments.length===0 ? (
                <div style={{ textAlign:'center', padding:20, color:'var(--text-muted)', fontSize:13 }}>No payments recorded yet.</div>
              ) : (
                <table>
                  <thead><tr><th>Date</th><th>Mode</th><th>Reference</th><th>Amount</th></tr></thead>
                  <tbody>
                    {payments.map((p,i)=>(
                      <tr key={i}>
                        <td style={{ fontSize:12 }}>{p.payment_date}</td>
                        <td><span className="badge badge-blue">{p.payment_mode}</span></td>
                        <td style={{ fontSize:12, color:'var(--text-muted)' }}>{p.reference_number||'—'}</td>
                        <td style={{ fontFamily:'DM Mono,monospace', fontWeight:600, color:'var(--green)' }}>{inr(p.amount)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          )}
        </div>

        {/* RIGHT — Summary */}
        <div>
          <div className="card" style={{ marginBottom:16 }}>
            <ST>Order Summary</ST>
            {[
              ['Subtotal', inr(subtotal)],
              [`Discount (${form.discount_percent}%)`, `-${inr(discountAmt)}`],
              ['Taxable Amount', inr(taxable)],
              [`CGST (${form.cgst_percent}%)`, inr(cgst)],
              [`SGST (${form.sgst_percent}%)`, inr(sgst)],
            ].map(([l,v],i)=>(
              <div key={i} style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid var(--border-light)', fontSize:13 }}>
                <span style={{ color:'var(--text-secondary)' }}>{l}</span>
                <span style={{ fontFamily:'DM Mono,monospace', fontWeight:500 }}>{v}</span>
              </div>
            ))}
            <div style={{ display:'flex', justifyContent:'space-between', padding:'12px 0', fontSize:15, fontWeight:700, borderTop:'2px solid var(--border)', marginTop:4 }}>
              <span>Total Amount</span>
              <span style={{ fontFamily:'DM Mono,monospace', color:'var(--brand)' }}>{inr(isEdit?order?.total_amount:total)}</span>
            </div>
            {isEdit&&<>
              <div style={{ display:'flex', justifyContent:'space-between', padding:'6px 0', fontSize:13 }}>
                <span style={{ color:'var(--green)' }}>Amount Paid</span>
                <span style={{ fontFamily:'DM Mono,monospace', color:'var(--green)', fontWeight:600 }}>{inr(paidAmt)}</span>
              </div>
              <div style={{ display:'flex', justifyContent:'space-between', padding:'6px 0', fontSize:14, fontWeight:700 }}>
                <span style={{ color:'var(--red)' }}>Balance</span>
                <span style={{ fontFamily:'DM Mono,monospace', color:'var(--red)', fontWeight:700 }}>{inr(balAmt)}</span>
              </div>
            </>}
            {!isEdit&&(
              <div style={{ marginTop:14 }}>
                <label className="form-label">Discount %</label>
                <input className="form-input" type="number" step="0.1" min="0" max="100" value={form.discount_percent} onChange={e=>setF('discount_percent',e.target.value)} placeholder="0"/>
              </div>
            )}
          </div>

          <div className="card">
            <ST>Actions</ST>
            {!isEdit && (
              <button className="btn btn-primary" style={{ width:'100%', marginBottom:10 }} onClick={handleSave} disabled={saving}>
                {saving?'Saving...':(isQuotation?'Save Quotation':'Create Order')}
              </button>
            )}
            {isEdit && <>
              <button className="btn btn-primary" style={{ width:'100%', marginBottom:8 }} onClick={()=>navigate(`/sales/invoice/${id}`)}>
                🖨 View Invoice
              </button>
              {order?.status==='CONFIRMED'&&(
                <button className="btn btn-secondary" style={{ width:'100%', marginBottom:8 }} onClick={()=>setShowDispatchModal(true)}>
                  🚛 Dispatch Order
                </button>
              )}
              {order?.status==='DRAFT'&&(
                <button className="btn btn-secondary" style={{ width:'100%', marginBottom:8 }} onClick={async()=>{ await api.patch(`/sales/orders/${id}/`,{status:'CONFIRMED'}); window.location.reload(); }}>
                  ✓ Confirm Order
                </button>
              )}
            </>}
          </div>
        </div>
      </div>

      {/* Payment Modal */}
      {showPayModal&&(
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center' }}>
          <div style={{ background:'var(--white)', borderRadius:'var(--radius)', padding:24, width:480, maxWidth:'90vw' }}>
            <div style={{ fontSize:15, fontWeight:600, marginBottom:16 }}>Record Payment</div>
            <div className="form-grid">
              <Field label="Amount (₹) *">
                <input className="form-input" type="number" step="0.01" value={payForm.amount} onChange={e=>setPF('amount',e.target.value)} placeholder="0.00"/>
              </Field>
              <Field label="Payment Date *">
                <input className="form-input" type="date" value={payForm.payment_date} onChange={e=>setPF('payment_date',e.target.value)}/>
              </Field>
              <Field label="Payment Mode *" full>
                <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(100px, 1fr))', gap:8 }}>
                  {PAYMENT_MODES.map(m=>(
                    <div key={m.val} onClick={()=>setPF('payment_mode',m.val)} style={{ padding:'8px', textAlign:'center', borderRadius:'var(--radius-sm)', cursor:'pointer', border:`2px solid ${payForm.payment_mode===m.val?'var(--brand)':'var(--border)'}`, background:payForm.payment_mode===m.val?'var(--brand-dim)':'var(--white)', fontSize:12, fontWeight:600, color:payForm.payment_mode===m.val?'var(--brand)':'var(--text-secondary)' }}>
                      {payForm.payment_mode===m.val?'✓ ':''}{m.label}
                    </div>
                  ))}
                </div>
              </Field>
              {(payForm.payment_mode==='BANK'||payForm.payment_mode==='CHEQUE'||payForm.payment_mode==='RAZORPAY')&&(
                <Field label="Reference Number" full>
                  <input className="form-input" value={payForm.reference_number} onChange={e=>setPF('reference_number',e.target.value)} placeholder={payForm.payment_mode==='CHEQUE'?'Cheque number':payForm.payment_mode==='BANK'?'Transaction ID':'Razorpay ID'}/>
                </Field>
              )}
              {payForm.payment_mode==='UPI'&&(
                <div style={{ gridColumn:'1/-1', textAlign:'center', padding:20, background:'var(--bg-primary)', borderRadius:'var(--radius-sm)', border:'2px dashed var(--border)' }}>
                  <div style={{ fontSize:13, color:'var(--text-muted)', marginBottom:8 }}>QR Code Payment</div>
                  <div style={{ fontSize:12, color:'var(--text-muted)' }}>Client QR code will be added here once received.</div>
                </div>
              )}
              <Field label="Notes" full>
                <input className="form-input" value={payForm.notes} onChange={e=>setPF('notes',e.target.value)} placeholder="Optional notes"/>
              </Field>
            </div>
            <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:16 }}>
              <button className="btn btn-secondary" onClick={()=>setShowPayModal(false)}>Cancel</button>
              <button className="btn btn-primary" onClick={handlePayment} disabled={saving}>{saving?'Saving...':'Record Payment'}</button>
            </div>
          </div>
        </div>
      )}

      {/* Dispatch Modal */}
      {showDispatchModal&&(
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center' }}>
          <div style={{ background:'var(--white)', borderRadius:'var(--radius)', padding:24, width:560, maxWidth:'90vw', maxHeight:'90vh', overflowY:'auto' }}>
            <div style={{ fontSize:15, fontWeight:600, marginBottom:16 }}>Dispatch Order</div>
            <div className="form-grid">
              <Field label="Dispatch Date *">
                <input className="form-input" type="date" value={dispForm.dispatch_date} onChange={e=>setDF('dispatch_date',e.target.value)}/>
              </Field>
              <Field label="Vehicle Number *">
                <input className="form-input" value={dispForm.vehicle_number} onChange={e=>setDF('vehicle_number',e.target.value)} placeholder="TN 33 AB 1234"/>
              </Field>
              <Field label="Driver Name">
                <input className="form-input" value={dispForm.driver_name} onChange={e=>setDF('driver_name',e.target.value)} placeholder="Driver name"/>
              </Field>
              <Field label="Driver Phone">
                <input className="form-input" value={dispForm.driver_phone} onChange={e=>setDF('driver_phone',e.target.value)} placeholder="Phone number"/>
              </Field>
              <Field label="Transport Company">
                <input className="form-input" value={dispForm.transport_company} onChange={e=>setDF('transport_company',e.target.value)} placeholder="Transport company name"/>
              </Field>
              <Field label="LR Number">
                <input className="form-input" value={dispForm.lr_number} onChange={e=>setDF('lr_number',e.target.value)} placeholder="Lorry receipt number"/>
              </Field>
              <Field label="Freight Amount (₹)">
                <input className="form-input" type="number" step="0.01" value={dispForm.freight_amount} onChange={e=>setDF('freight_amount',e.target.value)} placeholder="0.00"/>
              </Field>
            </div>
            <div style={{ marginTop:14, padding:12, background:'var(--bg-primary)', borderRadius:'var(--radius-sm)', border:'1px solid var(--border)' }}>
              <div style={{ fontSize:11, fontWeight:700, color:'var(--brand)', textTransform:'uppercase', letterSpacing:'1px', marginBottom:12 }}>Delivery Expenses</div>
              <div className="form-grid">
                <Field label="Driver Payment (₹)">
                  <input className="form-input" type="number" step="0.01" value={dispForm.driver_payment} onChange={e=>setDF('driver_payment',e.target.value)} placeholder="0.00"/>
                </Field>
                <Field label="Diesel Amount (₹)">
                  <input className="form-input" type="number" step="0.01" value={dispForm.diesel_amount} onChange={e=>setDF('diesel_amount',e.target.value)} placeholder="0.00"/>
                </Field>
                <Field label="Loading Charges (₹)">
                  <input className="form-input" type="number" step="0.01" value={dispForm.loading_charges} onChange={e=>setDF('loading_charges',e.target.value)} placeholder="0.00"/>
                </Field>
                <Field label="Unloading Charges (₹)">
                  <input className="form-input" type="number" step="0.01" value={dispForm.unloading_charges} onChange={e=>setDF('unloading_charges',e.target.value)} placeholder="0.00"/>
                </Field>
                <Field label="Other Expenses (₹)">
                  <input className="form-input" type="number" step="0.01" value={dispForm.other_expenses} onChange={e=>setDF('other_expenses',e.target.value)} placeholder="0.00"/>
                </Field>
                <Field label="Total Delivery Cost (Auto)">
                  <input className="form-input" readOnly
                    value={`₹${(parseFloat(dispForm.freight_amount||0)+parseFloat(dispForm.driver_payment||0)+parseFloat(dispForm.diesel_amount||0)+parseFloat(dispForm.loading_charges||0)+parseFloat(dispForm.unloading_charges||0)+parseFloat(dispForm.other_expenses||0)).toFixed(2)}`}
                    style={{ background:'var(--blue-bg)', color:'var(--brand)', fontWeight:700, cursor:'not-allowed' }}/>
                </Field>
              </div>
            </div>
            <div className="form-grid" style={{ marginTop:14 }}>
              <Field label="Delivery Address" full>
                <textarea className="form-input" rows={2} value={dispForm.delivery_address} onChange={e=>setDF('delivery_address',e.target.value)} placeholder="Full delivery address"/>
              </Field>
              <Field label="Notes" full>
                <textarea className="form-input" rows={2} value={dispForm.notes} onChange={e=>setDF('notes',e.target.value)} placeholder="Any dispatch notes"/>
              </Field>
            </div>
            <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:16 }}>
              <button className="btn btn-secondary" onClick={()=>setShowDispatchModal(false)}>Cancel</button>
              <button className="btn btn-primary" onClick={handleDispatch} disabled={saving}>{saving?'Dispatching...':'Confirm Dispatch'}</button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}